module.exports = function(vars) {
var __t, __p = '';
__p += '<nav id="menu" class="menu">\n</nav>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/menu.ejs